let currentSlide;

//Function for initializing .slick jquery on the cv-slick-slider container
$(document).ready(function(){
  $('.cv-slick-slider').on('init', function(event, slick) {
    $('.current').text(slick.currentSlide + 1);
    $('.total').text(slick.slideCount);
  }).slick({
    dots: false,
  }).on('beforeChange', function(event, slick, currentSlide, nextSlide) {
    $('.current').text(nextSlide + 1);
  });

  //Fuunction which opens up the currently active thumbnail in the product media
  // var images = $('.product__media-list li');
  // $( ".thumbnail" ).click(function() {
  //     for( let i = 0; i < images.length; i++){
  //       if(images.eq(i).hasClass('is-active')) {
  //         currentSlide = i;
  //          // initialCounterInfo();
  //         break;
  //       } else {
  //         currentSlide = 0;
  //       }
  //     }
  //   $('.cv-slick-slider').slick('slickGoTo', currentSlide);
  // });

  $('.product__media-list li').on('click', function(e) {
    var images = [];
    $('.product__media-list li').each(function() {
      images.push($(this).attr("data-media-id").split("-")[3]);
    });
    var clicked = $(e.target).attr("data-media-id").toString();
    var currentImage = images.indexOf(clicked);
    $('.cv-slick-slider').slick('slickGoTo', currentImage);
  })
});

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

var doc = window.document;
var docEl =  document.querySelector(".product-media-modal.cv-custom-selector-modal");
var closeButton = document.querySelector(".product-media-modal__toggle")
var fullScreenIndicator = 0;

//Function for Fullscreen toggle
function  openFullscreen() {
  var requestFullScreen = docEl.requestFullscreen || docEl.mozRequestFullScreen || docEl.webkitRequestFullScreen || docEl.msRequestFullscreen;
  var cancelFullScreen = doc.exitFullscreen || doc.mozCancelFullScreen || doc.webkitExitFullscreen || doc.msExitFullscreen;
  if(!doc.fullscreenElement && !doc.mozFullScreenElement && !doc.webkitFullscreenElement && !doc.msFullscreenElement) {
    requestFullScreen.call(docEl);
    fullScreenIndicator = 1;
    // closeButton.onclick = function() {
    //   cancelFullScreen.call(doc);
    //   $(".cv-slides").removeClass("cv-zoom");
    //   document.getElementById("cv-icon-fullscreen").src = 'https://cdn.shopify.com/s/files/1/0047/7016/8930/files/fullscreen_-_in.svg?v=1667532381'; 
    // };
  } else {
    cancelFullScreen.call(doc);
    fullScreenIndicator = 0;
  }
  document.getElementById("cv-icon-fullscreen").src = toggleFullscreenImg();
}

//Function for Zoom image icon toggle
function toggleZoomImg() {
  let initialImg = document.getElementById("cv-icon-zoom").src;
  let srcTest = initialImg.includes('https://cdn.shopify.com/s/files/1/0047/7016/8930/files/Zoom-in.svg?v=1667530256');
  let newImg = {
    'true':'https://cdn.shopify.com/s/files/1/0047/7016/8930/files/Zoom-out.svg?v=1667530256', 
    'false':'https://cdn.shopify.com/s/files/1/0047/7016/8930/files/Zoom-in.svg?v=1667530256'
  }[srcTest];

  return newImg;
}

//Function to assign correct zoom toggle image
function cvZoomImage() {
  document.getElementById("cv-icon-zoom").src = toggleZoomImg();
}

//Function for Fullscreen image icon toggle
function toggleFullscreenImg() {
  let initialImg = document.getElementById("cv-icon-fullscreen").src;
  let srcTest = initialImg.includes('https://cdn.shopify.com/s/files/1/0047/7016/8930/files/fullscreen_-_in.svg?v=1667532381');
  let newImg = {
    'true':'https://cdn.shopify.com/s/files/1/0047/7016/8930/files/fullscreen_-_out.svg?v=1667532381', 
    'false':'https://cdn.shopify.com/s/files/1/0047/7016/8930/files/fullscreen_-_in.svg?v=1667532381'
  }[srcTest];
  return newImg;
}

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

//Code snippet determins if mouse click is drag or click
let drag = false;
document.addEventListener(
  'mousedown', () => drag = false);
document.addEventListener(
  'mousemove', () => drag = true);
document.addEventListener(
  'touchmove', () => drag = true);
  document.addEventListener('touchend', () => console.log(drag ? 'drag' : 'click'));


///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//Code below is the behavior when the zoom icon is toggled
var zoomed = 0;

var elCanvas = document.querySelector(".slick-active > img");
var start = {x: 0, y: 0};
var offset = {x: 0, y: 0}; // The transform offset (from center)
var isPan = false;

$("#cv-zoom").click(function () {
  console.log("toggle Zoom")
  if (!drag) {
    $(".cv-slides").toggleClass("cv-zoom");
    document.querySelector(".slick-active > img").style.translate = `0px 0px`;
    if (!zoomed) {
      // console.log("Zoom In")
      $('.cv-slick-slider').slick("slickSetOption", "draggable", false, false);
      $('.cv-slick-slider').slick("slickSetOption", "swipe", false, false);
      $('.cv-slick-slider').slick("slickSetOption", "touchmove", false, false); 
      start = {x: 0, y: 0};
      offset = {x: 0, y: 0};
      elCanvas = document.querySelector(".slick-active > img");
    } else {
      // console.log("Zoom Out")
      $('.cv-slick-slider').slick("slickSetOption", "draggable", true, true);   
      $('.cv-slick-slider').slick("slickSetOption", "swipe", true, true);
      $('.cv-slick-slider').slick("slickSetOption", "touchmove", true, true);
    }
    zoomed = !zoomed;     
  }
});


//Code below is the behavior when the slide is clicked to toggle zoom
$('body').on('click touchend', '.slick-slide', function () { 
  console.log("Attempt to ZOOM")
  if (!drag) {
    $(".cv-slides").toggleClass("cv-zoom");
    document.getElementById("cv-icon-zoom").src = toggleZoomImg();
    document.querySelector(".slick-active > img").style.translate = `0px 0px`;
    if (!zoomed) {
      // console.log("Zoom In")
      $('.cv-slick-slider').slick("slickSetOption", "draggable", false, false);
      $('.cv-slick-slider').slick("slickSetOption", "swipe", false, false);
      $('.cv-slick-slider').slick("slickSetOption", "touchmove", false, false); 
      start = {x: 0, y: 0};
      offset = {x: 0, y: 0};
      elCanvas = document.querySelector(".slick-active > img");
    } else {
      // console.log("Zoom Out")
      $('.cv-slick-slider').slick("slickSetOption", "draggable", true, true);   
      $('.cv-slick-slider').slick("slickSetOption", "swipe", true, true);
      $('.cv-slick-slider').slick("slickSetOption", "touchmove", true, true);
    }
    zoomed = !zoomed;
  }
});

//Function to Start Panning on Mouse Down
const panStart = (ev) => {
  isPan = true;
  drag = true;
  ev.preventDefault();
  start.x = ev.clientX - offset.x;
  start.y = ev.clientY - offset.y;
  $('.cv-zoom').css('cursor', 'grab !important');
};

const panStartmobile = (ev) => {
  isPan = true;
  // drag = true;
  ev.preventDefault();
  start.x = ev.touches[0].clientX - offset.x;
  start.y = ev.touches[0].clientY - offset.y;
};

//Function to Move image on mouse drag
const panMove = (ev) => {
  drag = true;
    if (zoomed && isPan) {    
      $('.cv-zoom').css('cursor', 'grabbing !important');
      offset.x = ev.clientX - start.x;
      offset.y = ev.clientY - start.y;
      elCanvas.style.translate = `${offset.x}px ${offset.y}px`;
    } else { 
      return;
    }
};

const panMovemobile = (ev) => {
  // console.log("Moved")
  // console.log(zoomed)
  // console.log(isPan)
  drag = true;
    if (zoomed && isPan) {    
      $('.cv-zoom').css('cursor', 'grabbing !important');
      offset.x = ev.touches[0].clientX - start.x;
      offset.y = ev.touches[0].clientY - start.y;
      elCanvas.style.translate = `${offset.x}px ${offset.y}px`;
    } else { 
      return;
    }
};

//Function to End Panning on Mouse Up

const panEnd = (ev) => {
  isPan = false;
};

const panEndmobile = (ev) => {
  isPan = false;
  drag = false;
};


//Listeners for Panning action
$(".cv-slides").mousedown(panStart);
$(".cv-slides").on("touchstart", panStartmobile);
addEventListener("mousemove", panMove);
addEventListener("touchmove", panMovemobile);
addEventListener("mouseup", panEnd);
addEventListener("touchend", panEndmobile);


///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

$('body').on('click', '.slick-prev', function () {
  $(".cv-slides").removeClass("cv-zoom");
  zoomed = 0;
  document.querySelector(".slick-active > img").style.translate = `0px 0px`;
  document.getElementById("cv-icon-zoom").src = 'https://cdn.shopify.com/s/files/1/0047/7016/8930/files/Zoom-in.svg?v=1667530256';
})
$('body').on('click', '.slick-next', function () {
  $(".cv-slides").removeClass("cv-zoom");
  zoomed = 0;
  document.querySelector(".slick-active > img").style.translate = `0px 0px`;
  document.getElementById("cv-icon-zoom").src = 'https://cdn.shopify.com/s/files/1/0047/7016/8930/files/Zoom-in.svg?v=1667530256';
})

// $('body').on('click', '.slick-dots', function () {
//   $(".cv-slides").removeClass("cv-zoom");
//    document.getElementById("cv-icon-zoom").src = 'https://cdn.shopify.com/s/files/1/0047/7016/8930/files/Zoom-in.svg?v=1667530256';
// })

$('body').on('swipe', function() {
  $(".cv-slides").removeClass("cv-zoom");
  zoomed = 0;
  document.querySelector(".slick-active > img").style.translate = `0px 0px`;
  document.getElementById("cv-icon-zoom").src = 'https://cdn.shopify.com/s/files/1/0047/7016/8930/files/Zoom-in.svg?v=1667530256'; 
});

//Function to handle clicking of close button on the modal. fullScreenIndicator handles the bug where closing the modal in fullscreen
closeButton.onclick = function() {
  if (fullScreenIndicator) {
    openFullscreen();
  }
  if (zoomed) {
  document.getElementById("cv-icon-zoom").src = toggleZoomImg();
  zoomed = 0;
  }
  document.querySelector(".slick-active > img").style.translate = `0px 0px`;
  $(".cv-slides").removeClass("cv-zoom");
  document.getElementById("cv-icon-fullscreen").src = 'https://cdn.shopify.com/s/files/1/0047/7016/8930/files/fullscreen_-_in.svg?v=1667532381'; 
};